import React from 'react'
import { Loader } from 'ui-framework'

export function PreloaderContent() {
  return <Loader className="preloader-content" quantityDots={4} sizeDots="middle" title="Loading" />
}

export default React.memo(PreloaderContent)
